<template>
  <div class="alipay-container">
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/tradeMarkList' }">商标管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ id ? '编辑商标' : '新增商标' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card class="alipay-card" shadow="hover">
      <div slot="header" class="card-header-title">
        <span>{{ id ? '编辑商标信息' : '新增商标信息' }}</span>
      </div>

      <el-form :model="form" :rules="rules" ref="formRef" label-width="110px" label-position="right" size="default">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商标名称" prop="name">
              <el-input v-model="form.name" placeholder="请输入商标名称"></el-input>
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
            <el-form-item label="商标注册号" prop="reg_sn">
              <el-input v-model="form.reg_sn" placeholder="请输入注册号"></el-input>
            </el-form-item>
          </el-col>

          <!-- 商标大类 -->
          <el-col :span="12">
            <el-form-item label="商标大类" prop="category_big_id">
              <el-select v-model="form.category_big_id" placeholder="请选择商标大类" @change="changeBigCategory">
                <el-option v-for="item in categoryBigList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 商标小类（多选） -->
          <el-col :span="12">
            <el-form-item label="商标小类" prop="category_small_ids">
              <el-select
                v-model="form.category_small_ids"
                multiple
                collapse-tags
                placeholder="请先选择大类"
                :disabled="!form.category_big_id"
                style="width:100%;"
              >
                <el-option
                  v-for="item in categorySmallList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="申请日期" prop="apply_date">
              <el-date-picker v-model="form.apply_date" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="联系人" prop="cont_name">
              <el-input v-model="form.cont_name" placeholder="联系人"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="联系电话" prop="telephone">
              <el-input v-model="form.telephone" placeholder="电话"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="所属行业">
              <el-cascader v-model="form.industry_id" :props="industryProps" :options="industryOptions" placeholder="请选择"></el-cascader>
            </el-form-item>
          </el-col>

          <!-- 商标图片上传 -->
          <el-col :span="24">
            <el-form-item label="商标图片">
              <el-upload
                action="/api/upload"
                list-type="picture-card"
                :limit="1"
                :on-success="handleUploadSuccess"
                :file-list="fileList"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="tip-text">支持jpg/png，单张图片大小不超过2M</div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="商标状态">
              <el-select v-model="form.status" disabled>
                <el-option label="待审核" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="商标地址">
              <el-input v-model="form.address" type="textarea" rows="3" placeholder="详细地址"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.remark" type="textarea" rows="3" placeholder="备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="form-footer">
          <el-button @click="$router.go(-1)">返回</el-button>
          <el-button type="primary" @click="submitForm">保存提交</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name:'tradeMarkForm',
  data(){
    return{
      id:'',
      categoryBigList: [],
      categorySmallMap: {},
      categorySmallList: [],
      industryOptions:[],
      industryProps:{value:'id',label:'name',children:'children'},
      fileList: [],
      form:{
        name:'',
        reg_sn:'',
        category_big_id:'',
        category_small_ids:[],  // 修复：多选必须数组
        apply_date:'',
        cont_name:'',
        telephone:'',
        industry_id:[],
        img_url:'',
        address:'',
        status:0,
        remark:''
      },
      rules:{
        name:[{required:true,message:'请输入商标名称',trigger:'blur'}],
        reg_sn:[{required:true,message:'请输入注册号',trigger:'blur'}],
        category_big_id:[{required:true,message:'请选择商标大类',trigger:'change'}],
        category_small_ids:[{required:true,message:'请选择商标小类',trigger:'change'}],
        cont_name:[{required:true,message:'请输入联系人',trigger:'blur'}],
        telephone:[{required:true,message:'请输入电话',trigger:'blur'}]
      }
    }
  },
  created(){
    this.id = this.$route.query.id;
    this.getBaseData();
    if(this.id) this.loadData();
  },
  methods:{
    getBaseData(){
      this.categoryBigList = [
        {id:1,name:'第1类 化工原料'},
        {id:9,name:'第9类 科学仪器'},
        {id:25,name:'第25类 服装鞋帽'},
        {id:35,name:'第35类 广告销售'}
      ];
      this.categorySmallMap = {
        1: [{id:101,name:'0101工业化工'},{id:102,name:'0102农用化工'}],
        9: [{id:901,name:'0901电子仪器'},{id:902,name:'0902安防设备'}],
        25: [{id:2501,name:'2501服装'},{id:2502,name:'2502鞋帽'}],
        35: [{id:3501,name:'3501广告'},{id:3502,name:'3502电商服务'}]
      };
      this.industryOptions=[
        {id:1,name:'互联网',children:[{id:11,name:'电商'},{id:12,name:'软件'}]},
        {id:2,name:'实体',children:[{id:21,name:'餐饮'},{id:22,name:'零售'}]}
      ];
    },
    changeBigCategory(bigId){
      this.categorySmallList = this.categorySmallMap[bigId] || [];
      this.form.category_small_ids = [];
    },
    handleUploadSuccess(res){
      this.form.img_url = res.data.url;
      this.$message.success('图片上传成功');
    },
    loadData(){
      this.form = {
        name:'星辰',
        reg_sn:'TM2025002',
        category_big_id:25,
        category_small_ids:[2501],
        apply_date:'2025-01-01',
        cont_name:'李四',
        telephone:'13800002222',
        industry_id:[2,22],
        img_url:'https://oss.xxx.com/demo.png',
        address:'杭州市',
        status:0,
        remark:'测试'
      };
      this.changeBigCategory(25);
      this.fileList = [{url:this.form.img_url}];
    },
    submitForm(){
      this.$refs.formRef.validate(valid=>{
        if(valid){
          this.$message.success(this.id ? '修改成功' : '新增成功');
          this.$router.push('/tradeMarkList');
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {padding:16px 20px;background:#f5f7fa;min-height:calc(100vh - 60px);}
.breadcrumb-wrapper{margin-bottom:16px;}
.alipay-card{border-radius:12px;}
.card-header-title{font-weight:500;font-size:16px;}
.form-footer{display:flex;justify-content:center;gap:12px;margin-top:30px;}
.tip-text{font-size:12px;color:#999;margin-top:8px;}
</style>